import CustomAnchorTag from "../../../Common/CommonComponents/CustomAnchorTag/customAnchorTag";
import Card from "../../../Common/CommonComponents/Card/card";
import classes from "./moreResDetails.scss";

const MoreResDetails = (props) => {
    return (
        <Card>
            <div className="sce-center-alg">
                <div><img className={classes.sceResourceIcon} src={props.imgSrc} alt="resource icon" /></div>
                <div className={"sce-space-md "+classes.sceMoreResMsg}>{props.message}</div>
                <div className="sce-space-md"><CustomAnchorTag id={props.id} name={props.name} dataToggle={props.dataToggle} dataTarget={props.dataTarget} linkName={props.linkName} link={props.link} onClick={props.onClick} isBold /></div>
            </div>
        </Card>
    );
};

export default MoreResDetails;